import { React, useEffect } from "react";

function CustomSearch(props) {
  const { searchSkeleton, rawData, customSearchText, onAdminSearchFilter } = props;

  let searchText = [];

  const tokenizeSearchString = (searchString) => {
    const tempKeys = searchString ? searchString.split(/[^\w'!-:]+/) : [];
    const searchTokens = [];
    for (let index = 0, max = tempKeys.length; index < max; index++) {
      if (tempKeys[index]) {
        searchTokens.push(tempKeys[index]);
      }
    }
    return searchTokens;
  };

  const doCustomSearch = (sourceFunction, item) => {
    if (typeof sourceFunction !== "function") {
      console.log("doCustomSearch default");
      return false;
    }

    // Filter out empty search text
    const validSearchTexts = searchText.filter((text) => text !== "");

    // Use Array.prototype.some() to exit early if a match is found
    return validSearchTexts.some((searchToken) => {
      try {
        return sourceFunction(searchToken, item);
      } catch (e) {
        // ignore errors
        return false;
      }
    });
  };
  const doStringSearch = (sourceText) => {
    return searchText.some((searchTerm) => {
      if (searchTerm === "") return false; // Skip empty search terms

      try {
        return sourceText.toLowerCase().indexOf(searchTerm) > -1;
      } catch (e) {
        // ignore errors
        return false;
      }
    });
  };

  const doArraySearch = (sourceText) => {
    const joinedSourceText = sourceText.join(",").toLowerCase();

    return searchText.some((searchTerm) => {
      // Skip empty search terms
      if (searchTerm === "") return false;

      try {
        return joinedSourceText.indexOf(searchTerm) > -1;
      } catch (e) {
        // ignore errors
        return false;
      }
    });
  };

  const doTimestampSearch = (sourceText) => {
    return searchText.some((searchToken) => {
      if (searchToken === "") {
        return false; // Skip empty search terms
      }

      try {
        switch (searchToken) {
          case "now":
          case "today": {
            const sourceDate = new Date(sourceText);
            const searchDate = new Date();
            return sourceDate.getDate() === searchDate.getDate() && sourceDate.getMonth() === searchDate.getMonth() && sourceDate.getFullYear() === searchDate.getFullYear();
          }

          case "yesterday":
          case "-1": {
            const sourceDate = new Date(sourceText);
            const searchDate = new Date();
            searchDate.setDate(searchDate.getDate() - 1);
            return sourceDate.getDate() === searchDate.getDate() && sourceDate.getMonth() === searchDate.getMonth() && sourceDate.getFullYear() === searchDate.getFullYear();
          }

          case "tomorrow":
          case "1":
          case "+1": {
            const sourceDate = new Date(sourceText);
            const searchDate = new Date();
            searchDate.setDate(searchDate.getDate() + 1);
            return sourceDate.getDate() === searchDate.getDate() && sourceDate.getMonth() === searchDate.getMonth() && sourceDate.getFullYear() === searchDate.getFullYear();
          }

          default: {
            const searchTokenNumber = parseInt(searchToken, 10);
            return sourceText == searchTokenNumber || sourceText.toString().indexOf(searchToken) > -1;
          }
        }
      } catch (e) {
        // ignore errors
        return false;
      }
    });
  };

  const checkMatch = (item) => {
    if (!searchSkeleton || !searchText || searchText.length === 0) {
      return true;
    }

    // Convert the keys of searchSkeleton to an array
    const keys = Object.keys(searchSkeleton);

    // Use some to iterate over the keys and return true if any match
    return keys.some((key) => {
      const valueType = searchSkeleton[key];
      const itemValue = item[key];

      if (key === "customMethod") {
        return doCustomSearch(searchSkeleton[key], item);
      }

      if (!itemValue) {
        return false;
      }

      try {
        switch (valueType) {
          case "string":
            return doStringSearch(itemValue);
          case "array":
            return doArraySearch(itemValue);
          case "timestamp":
            return doTimestampSearch(itemValue);
          case "number":
            return doStringSearch(itemValue.toString());
          default:
            return false;
        }
      } catch (e) {
        // Handle errors centrally if needed
        return false;
      }
    });
  };

  const filterData = () => {
    searchText = tokenizeSearchString(customSearchText);
    if (!searchText || searchText.length == 0) {
      onAdminSearchFilter(rawData);
      return;
    }
    const filteredData = [];
    if (searchSkeleton && rawData) {
      rawData.forEach((item) => {
        switch (typeof item) {
          case "object":
            try {
              if (checkMatch(item)) {
                filteredData.push(item);
              }
            } catch (e) {
              // ignore
            }
            break;
          case "string":
            try {
              if (doStringSearch(item)) {
                filteredData.push(item);
              }
            } catch (e) {
              // ignore
            }
            break;
          default:
            try {
              if (doStringSearch(JSON.stringify(item))) {
                filteredData.push(item);
              }
            } catch (e) {
              // ignore
            }
            break;
        }
      });
      onAdminSearchFilter(filteredData);
    }
  };

  useEffect(() => {
    console.log("CustomSearch Mount");
    filterData();
    return () => {
      console.log("CustomSearch Destroy");
    };
  }, [customSearchText]);

  return <div />;
}

export default CustomSearch;
